// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"ec3397b2","455":"2c94539e","977":"342b2b63"}[chunkId] + ".chunk.js";
};